/**
 * desc: 兼容无痕模式sessionStorage和localStorage
 */
let virtualSS = {}
let virtualLS = {}

export default {
  sessionStorage: {
    setItem(key, value) {
      try {
        sessionStorage.setItem(key, value)
      } catch (err) {
        virtualSS[key] = value
      }
    },
    getItem(key) {
      try {
        const value = sessionStorage.getItem(key) || virtualSS[key]
        return value === undefined ? null : value
      } catch(err) {
        return virtualSS[key]
      }
    },
    removeItem(key) {
      try {
        sessionStorage.removeItem(key)
      } catch(err) {
        delete virtualSS[key]
      }
    },
    clear() {
      try {
        sessionStorage.clear()
      } catch(err) {
        virtualSS = {}
      }
    }
  },
  localStorage: {
    setItem(key, value) {
      try {
        localStorage.setItem(key, value)
      } catch(err) {
        virtualLS[key] = value
      }
    },
    getItem(key) {
      try {
        const value = localStorage.getItem(key) || virtualLS[key]
        return value === undefined ? null : value
      } catch (err) {
        return virtualLS[key]
      }
    },
    removeItem(key) {
      try {
        localStorage.removeItem(key)
      } catch(err) {
        delete virtualLS[key]
      }
    },
    clear() {
      try {
        localStorage.clear()
      } catch (err) {
        virtualLS = {}
      }
    }
  }
}